import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.addTag({ name: 'description', content: 'Enability Foundation for Rehabilitation' });
    this.meta.addTag({ name: 'keywords', content: 'Enability, Disable, phsical change people, rehabilitation, multi personality, education for disabled' });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/homepage/homepage.component.ts